export default {
      id: "man-usage",
      viewBox: "0 0 12 33",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#man",
      toString: function () {
        return this.url;
      }
    }